import { call, put, select, takeEvery } from 'redux-saga/effects';
import { types, getAvailableLanguagesSuccessAction } from '@actions/trscService';
import { types as conferenceTypes } from '@actions/conference';
import { getAvailableLanguagesList } from '@services/trscService';
import { tokenSelector } from '@selectors/authentication';

export function* getAvailableLanguagesSaga(action) {
  try {
    const token = yield select(tokenSelector);
    if (!token) return false;
    const { data } = yield call(getAvailableLanguagesList, token, action.payload);

    yield put(getAvailableLanguagesSuccessAction(data));
  } catch (err) {
    yield put({
      type: types.GET_AVAILABLE_LANGUAGES.FAILURE,
      message: err.message || 'Error while fetching languages.',
    });
  }
}

export default function*() {
  yield takeEvery(types.GET_AVAILABLE_LANGUAGES.REQUEST, getAvailableLanguagesSaga);
}



// WEBPACK FOOTER //
// ./redux/sagas/trscService.js